import { CountUp } from '../../vendors/countUp.min.js';

// Counters
export function countStart() {
  const $counters = document.querySelectorAll('.counter-value'),
        options = {
          duration: 3,
          enableScrollSpy: true,
          scrollSpyDelay: 300,
          scrollSpyOnce: true,
          useEasing: true,
          useGrouping: false,
          separator: '.',
          decimal: '.'
        };

  $counters.forEach( (item) => {
    const value = item.innerText;
    const counter = new CountUp(item, value, options);
    counter.start();
  });
}
